import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getVendorsByCountryState } from 'actions/EntityActions';
import { getPurchaseOrderReceiver, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import PageHeader from 'screens/components/basic/PageHeader';
import Grid from 'screens/components/basic/Grid';
import { reportPurchaseOrderReceiver } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';

class PurchaseOrderReceiver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0,
                SKU: 0,
                POID: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `PurchaseOrderReceiverBeginDate`);
        this.props.formInput(date, `PurchaseOrderReceiverEndDate`);
        if (localStorage.getItem("PurchaseOrderReceiverBranchIds") != null) {
            this.props.formInput(localStorage.getItem("PurchaseOrderReceiverBranchIds").split(","), "PurchaseOrderReceiverBranchIds")
        }
        this.props.getVendors(this.props.store.country, this.props.store.provinceState);
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedBranchIds != undefined && this.props.selectedBranchIds != prevProps.selectedBranchIds) {
            localStorage.setItem("PurchaseOrderReceiverBranchIds", this.props.selectedBranchIds)
        }
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.selectedBranchIds.join(",") || this.props.branchOptions.map(item => item.value).join(",");
        let SKU = this.props.SKU || '';
        let POID = this.props.POID || 0;
        let vendor = this.props.vendor || 0
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let recordTypeSelect = this.props.recordTypeSelect;

        this.props.getPurchaseOrderReceiver({ beginDate, endDate, SKU, POID, pageNumber, pageSize, branch, vendor, recordTypeSelect });

    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.selectedBranchIds.join(",") || this.props.branchOptions.map(item => item.value).join(",");
        let SKU = this.props.SKU || '';
        let POID = this.props.POID || 0;
        let vendor = this.props.vendor || 0
        let pageNumber = 1;
        let pageSize = 999999;
        let recordTypeSelect = this.props.recordTypeSelect;

        this.props.getCsvReport(`reports/excel/poreceiver?beginDate=${beginDate}&endDate=${endDate}&SKU=${SKU}&POID=${POID}&branch=${branch}&vendor=${vendor}&pageNumber=${pageNumber}&pageSize=${pageSize}&recordTypeSelect=${recordTypeSelect}`, "poreceiver");
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.poReceiverReport && newProps.poReceiverReport != this.props.poReceiverReport) {
            const totalRow = newProps.poReceiverReport && newProps.poReceiverReport.length > 0 ? newProps.poReceiverReport[0].totalrow : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    render() {
        return (
            <Grid headerContent={reportPurchaseOrderReceiver}>
                <PageHeader title={LOOKUP.report.purchaseOrderReceiver.text}
                    description={LOOKUP.report.purchaseOrderReceiver.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch}
                    branchOptions={this.props.brachOptions}
                    vendorOptions={this.props.vendorOptions}
                    provinceOptions={this.props.provinceOptions}
                    selectedProvince={this.props.selectedProvince}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody} />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody && this.props.poReceiverReport &&
                    <CardSimple>
                        <Body purchaseOrderReceiver={this.props.poReceiverReport} branch={this.props.branch} beginDate={this.props.beginDate} endDate={this.props.endDate} branches={this.props.brachOptions} />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let vendors = state.entity.vendorList || [];
    let vendorOptions = [];
    vendors.map((vendor) => {
        if (vendor.status === 'Active') {
            vendorOptions.push(
                { text: vendor.name, value: parseInt(vendor.id) }
            );
        }
    })
    vendorOptions.unshift({ text: "All", value: "0" })


    let provinceOptions = [
        { text: "All", value: "All" },
        { text: "BC", value: "BC" },
        { text: "AB", value: "AB" },
        { text: "MB", value: "MB" },
        { text: "SK", value: "SK" },
        { text: "ON", value: "ON" }
    ]

    return {
        store: state.common.store,
        brachOptions: brachOptions,
        vendorOptions: vendorOptions,
        provinceOptions: provinceOptions,
        poReceiverReport: state.reports.poReceiverReport,
        loggedBranch: state.common.branchId,
        beginDate: state.form.PurchaseOrderReceiverBeginDate,
        endDate: state.form.PurchaseOrderReceiverEndDate,
        SKU: state.form.PurchaseOrderReceiverSKU,
        POID: state.form.PurchaseOrderReceiverPOID,
        vendor: state.form.PurchaseOrderReceiverVendor,
        selectedBranchIds: state.form.PurchaseOrderReceiverBranchIds,
        recordTypeSelect: state.form.PurchaseOrderReceiverRecordTypeSelect,
        selectedProvince: state.form.PurchaseOrderReceiverProvince
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPurchaseOrderReceiver: model => dispatch(getPurchaseOrderReceiver(model)),
        getVendors: (country, provinceState) => dispatch(getVendorsByCountryState(country, provinceState)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PurchaseOrderReceiver));